export default __webpack_public_path__ + "static/media/checking.8df39a85.svg";